import React from 'react';

export default function KeyPoints({ children }) {
	let gridColsClass = 'md:grid-cols-3';

	if (children?.length === 1) {
		gridColsClass = 'md:grid-cols-1';
	} else if (children?.length === 2) {
		gridColsClass = 'md:grid-cols-2';
	}

	return <div className={`grid grid-cols-1 ${gridColsClass} w-full pb-20`}>{children}</div>;
}
